import { useFormik } from "formik";
import { NumericFormat } from "react-number-format";
import { AddLoanProductPayload } from "../../../../../redux/features/loans/loans.type";
import { addLoanProductSchema } from "../../../../../validationSchema";
import { Button } from "../../../../buttons/button";
import { TextInput } from "../../../../inputs/textInput";

export const LoanInformation = ({
  finalPayload,
  setFinalPayload,
  mode,
  onSuccess,
}: {
  finalPayload: AddLoanProductPayload;
  setFinalPayload: (data: AddLoanProductPayload) => void;
  mode: "create" | "edit";
  onSuccess: () => void;
}) => {
  const {
    values,
    errors,
    handleChange,
    handleBlur,
    handleSubmit,
    touched,
    isValid,
  } = useFormik({
    initialValues: {
      loanName: finalPayload?.loanName,
      loanDescription: finalPayload?.loanDescription,
      maxGuarantor: finalPayload?.maxGuarantor,
      minMonthJoined: finalPayload?.minMonthJoined,
      maxTenure: finalPayload?.maxTenure,
    },
    enableReinitialize: true,
    validationSchema: addLoanProductSchema,
    onSubmit: (data) => {
      setFinalPayload({ ...finalPayload, ...data });
      onSuccess();
    },
  });

  return (
    <form
      className="w-full flex flex-col gap-4 hide-scroll-bar"
      onSubmit={handleSubmit}
    >
      <TextInput
        type="text"
        name={"loanName"}
        value={values?.loanName ?? ""}
        placeholder="Enter loan name"
        onBlur={handleBlur}
        onChange={handleChange}
        errors={errors?.loanName && touched?.loanName ? errors?.loanName : ""}
        inputClass=""
        className=""
        hasIcon={false}
        hasTitle
        title="Loan Name"
      />

      <TextInput
        type="textarea"
        name={"loanDescription"}
        value={values?.loanDescription ?? ""}
        placeholder="Write something brief about the loan"
        onBlur={handleBlur}
        onChange={handleChange}
        hasIcon={false}
        errors={
          errors?.loanDescription && touched?.loanDescription
            ? errors?.loanDescription
            : ""
        }
        inputClass=""
        className=""
        customIconPosition="left"
        hasTitle
        title="Loan Description"
        rows={3}
      />

      <NumericFormat
        suffix={undefined}
        prefix={undefined}
        decimalScale={0}
        thousandSeparator
        allowLeadingZeros={false}
        customInput={TextInput}
        onBlur={handleBlur}
        onChange={handleChange}
        type="text"
        name={"maxGuarantor"}
        value={values.maxGuarantor}
        placeholder="Enter maximum number of guarantors"
        errors={
          errors?.maxGuarantor && touched?.maxGuarantor
            ? errors?.maxGuarantor
            : ""
        }
        inputClass=""
        className=""
        customIconPosition="right"
        hasTitle
        hasIcon={false}
        title="Maximum Number of Guarantors"
      />

      <NumericFormat
        suffix={undefined}
        prefix={undefined}
        decimalScale={0}
        thousandSeparator
        allowLeadingZeros={false}
        customInput={TextInput}
        onBlur={handleBlur}
        onChange={handleChange}
        placeholder="Enter number of months"
        type="text"
        name={"minMonthJoined"}
        value={values.minMonthJoined}
        errors={
          errors?.minMonthJoined && touched?.minMonthJoined
            ? errors?.minMonthJoined
            : ""
        }
        inputClass=""
        className="!p-0 !pl-4"
        customIcon={
          <div
            className="
                  font-medium text-sm md:text-sm
                  py-[14px] px-[16px]
                  bg-white
                  border border-pry-dark-green-300/10
                  rounded-e-lg
                  "
          >
            Months
          </div>
        }
        customIconPosition="right"
        hasTitle
        title="Minimum Membership Months"
      />

      <NumericFormat
        suffix={undefined}
        prefix={undefined}
        decimalScale={0}
        thousandSeparator
        allowLeadingZeros={false}
        customInput={TextInput}
        onBlur={handleBlur}
        onChange={handleChange}
        type="text"
        name={"maxTenure"}
        value={values.maxTenure}
        placeholder="Enter number of months"
        errors={
          errors?.maxTenure && touched?.maxTenure ? errors?.maxTenure : ""
        }
        inputClass=""
        className="!p-0 !pl-4"
        customIcon={
          <div
            className="
                  font-medium text-sm md:text-sm
                  py-[14px] px-[16px]
                  bg-white
                  border border-pry-dark-green-300/10
                  rounded-e-lg
                  "
          >
            Months
          </div>
        }
        customIconPosition="right"
        hasTitle
        title="Maximum Loan Tenor"
      />

      <hr className="border-pry-dark-green-300/10" />

      <Button
        type="submit"
        className="w-full"
        variation="primary"
        text="Proceed"
        disabled={!isValid}
      />
    </form>
  );
};
